module.exports = __webpack_public_path__ + "04e8b9479f9006926ffdb36c95e482ed.png";